import { useState, useMemo } from 'react'
import { Pin, Category, User } from '../types'
import { mockPins as initialPins } from '../data/mockPins'

const currentUser: User = {
  id: 'current',
  name: 'You',
  username: '@you',
  avatar:
    'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80',
}

export function usePins() {
  const [pins, setPins] = useState<Pin[]>(initialPins)
  const [selectedCategory, setSelectedCategory] = useState<Category>('All')

  const filteredPins = useMemo(() => {
    if (selectedCategory === 'All') return pins
    return pins.filter((pin) => pin.category === selectedCategory)
  }, [pins, selectedCategory])

  const addPin = (pinData: Partial<Pin>) => {
    const newPin: Pin = {
      id: `p${Date.now()}`,
      title: pinData.title || 'Untitled',
      description: pinData.description || '',
      imageUrl: pinData.imageUrl || '',
      width: 600,
      height: 800,
      user: currentUser,
      likes: 0,
      category: pinData.category || 'Art',
      ...pinData,
    } as Pin
    setPins([newPin, ...pins])
  }

  const toggleLike = (pinId: string) => {
    setPins(
      pins.map((pin) => {
        if (pin.id === pinId) {
          return {
            ...pin,
            isLiked: !pin.isLiked,
            likes: pin.isLiked ? pin.likes - 1 : pin.likes + 1,
          }
        }
        return pin
      }),
    )
  }

  const savePin = (pinId: string, boardId: string) => {
    setPins(
      pins.map((pin) => {
        if (pin.id === pinId) {
          return {
            ...pin,
            isSaved: true,
            boardId,
          }
        }
        return pin
      }),
    )
  }

  return {
    pins: filteredPins,
    allPins: pins,
    selectedCategory,
    setSelectedCategory,
    addPin,
    toggleLike,
    savePin,
    currentUser,
  }
}
